import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-practice-test-card',
  templateUrl: './practice-test-card.component.html',
  styleUrls: ['./practice-test-card.component.css']
})
export class PracticeTestCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
